import React from "react";

const Loader = () => {
  return (
    <div className="page-loader-wrapper">
      <div className="page-loader"></div>
    </div>
  );
};
export default Loader;
